var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFF",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    viewBox: "0 0 30 36",
    width: 30,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M20.9911 2.625H8.4375c-.3452 0-.625.2798-.625.625v29.25c0 .3452.2798.625.625.625h18.125c.3452 0 .625-.2798.625-.625V10.0607c0-.1658-.0659-.3247-.1831-.4419l-5.5893-5.5893c-.1172-.1172-.2761-.1831-.4419-.1831z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#D3D3D3",
    d: "M20.9375 2.625v5.625c0 .3452.2798.625.625.625h5.625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.6875 22.875h-9.6875v-.625h9.6875c.1726 0 .3125.1399.3125.3125s-.1399.3125-.3125.3125zm0-1.875h-9.6875v-.625h9.6875c.1726 0 .3125.1399.3125.3125s-.1399.3125-.3125.3125zm0-1.875h-9.6875v-.625h9.6875c.1726 0 .3125.1399.3125.3125s-.1399.3125-.3125.3125zm0-1.875h-9.6875v-.625h9.6875c.1726 0 .3125.1399.3125.3125s-.1399.3125-.3125.3125zm0 7.5h-9.6875v-.625h9.6875c.1726 0 .3125.1399.3125.3125s-.1399.3125-.3125.3125z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "darkgray",
    d: "M3.75 27.75h10c.6904 0 1.25-.5596 1.25-1.25V14.25c0-.6904-.5596-1.25-1.25-1.25h-10c-.6904 0-1.25.5596-1.25 1.25v12.25c0 .6904.5596 1.25 1.25 1.25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.7577 22.7421c.0207.1631.0341.3053.0405.4268h.0238c.0096-.1152.0278-.254.0547-.4172.0269-.1628.0532-.3003.0787-.4122L8.0597 16.5h1.4282l1.1426 4.7273c.0572.2334.1048.5304.1428.8916h.019c.0159-.2493.0555-.5370.1190-.8630l.9682-4.7559H13.125l-1.5995 6.875h-1.5188l-1.0902-4.5545c-.0317-.1311-.0674-.3019-.1071-.5130-.0397-.2108-.0643-.3643-.0738-.4601h-.019c-.0127.1119-.0373.2780-.0739.4984-.0365.2207-.0659.3835-.0881.4891l-.9841 4.5401H6.2051L4.375 16.5h1.3234l.9951 4.8088c.0222.0989.0435.2301.0642.3928z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.b58c8edba25a9c58647a79a61e004cb0.svg";
export { ForwardRef as ReactComponent };